import isEmpty from 'lodash/isEmpty'

export function checkEmailValidity(value: string): boolean {
  const email = value.trim()
  const basicEmailRegex = /^\S+@\S+\.\S+$/
  return !(isEmpty(email) || !email || basicEmailRegex.exec(email) === null)
}
